import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DataList from '../DataList';
import ApiConfigFactory from '../../configurations/ApiConfigFactory';

const ReportList = () => {
  const navigate = useNavigate();
  const dlConfig = new ApiConfigFactory(
    'reports',
    'Reports',
    null,
    null
  );

  dlConfig.title = 'All Reports';
  dlConfig.formTitle = 'Report Details';
  dlConfig.allowAdd = true;
  dlConfig.path = '/reports';
  dlConfig.useLocalCaching = false;
  dlConfig.defaultSortFieldId = 'report_id';
  dlConfig.defaultSortAsc = false;
  dlConfig.fetchEndpoint = '/hospital-portal/api/reports?manage=1';
  dlConfig.cloneOmitFields = ['report_id'];
  dlConfig.cloneTransform = (clonedRecord, sourceRecord) => ({
    ...clonedRecord,
    report_id: undefined,
    report_title: sourceRecord?.report_title ? `${sourceRecord.report_title} (Copy)` : 'New Report Copy',
  });
  dlConfig.bulkActions = [
    { name: 'Clone', type: 'clone' },
  ];
  dlConfig.onEdit = (record) => {
    if (record?.report_id) {
      navigate(`/reports/${record.report_id}/edit`);
    }
  };
  dlConfig.onBeforeAdd = () => {
    navigate('/reports/new/edit');
    return false;
  };

  dlConfig.addField({ name: 'report_id', label: 'Report ID', type: 'text', identifier: true, disabled: true, tab: 'Details' })
    .addField({ name: 'report_title', label: 'Report Title', type: 'text', required: true, tab: 'Details' })
    .addField({ name: 'category', label: 'Category', type: 'text', required: false, tab: 'Details' })
    .addField({ name: 'description', label: 'Description', type: 'text', required: false, tab: 'Details' })
    .addField({ name: 'sort_order', label: 'Sort Order', type: 'number', required: false, tab: 'Details' })
    .addField({ name: 'icon', label: 'Icon', type: 'text', required: false, tab: 'Details' })
    .addField({ name: 'permission_roles', label: 'Permission Roles', type: 'text', required: true, tab: 'Details' })
    .addField({ name: 'createdAt', label: 'Created At', type: 'datetime', required: false, tab: 'Admin', disabled: true })
    .addField({ name: 'updatedAt', label: 'Updated At', type: 'datetime', required: false, tab: 'Admin', disabled: true });

  dlConfig.addTab({ name: 'Details', roles: 'all', default: true })
    .addTab({ name: 'Admin', roles: 'Admin' });

  dlConfig.addColumn({ id: 'report_id', name: 'Report ID', selector: (row) => row.report_id, type: 'text', sortable: true, identifier: true, width: '110px', filterable: true })
    .addColumn({ name: 'Report Title', selector: (row) => row.report_title, type: 'text', sortable: true, filterable: true })
    .addColumn({ name: 'Category', selector: (row) => row.category || 'Uncategorized', type: 'text', sortable: true, filterable: true, width: '140px' })
    .addColumn({
      name: 'Designer',
      selector: (row) => (
        <Link to={`/reports/${row.report_id}/edit`}>Edit in designer</Link>
      ),
      type: 'text',
      sortable: false,
      width: '150px',
    })
    .addColumn({ name: 'Created At', selector: (row) => row.createdAt, type: 'datetime', sortable: true })
    .addColumn({ name: 'Updated At', selector: (row) => row.updatedAt, type: 'datetime', sortable: true });

  return <DataList apiConfig={dlConfig} columns={dlConfig.columns} />;
};

export default ReportList;
